import { HydrateOption } from '@core/enums';
import { isSSR } from '@helpers/ssr';
import withWidget from '@hoc/withWidget';
import Loader from '@stories/Components/Misc/Loader/Loader';
import { YSContextProvider } from '@stories/Widgets/YourSolution/YS/Context/YSContext';
import React, { lazy, Suspense } from 'react';
const YourSolutionLazy = lazy(() => import('./YourSolution'));
const YourSolutionRoot = (props) => {
    if (isSSR()) {
        return React.createElement(Loader, { delay: 500 });
    }
    return (React.createElement(YSContextProvider, { ...props },
        React.createElement(Suspense, { fallback: React.createElement(Loader, { delay: 500 }) },
            React.createElement(YourSolutionLazy, { closeModal: () => !isSSR() && window.history.back(), ...props }))));
};
// The YS app itself is already lazy-loaded behind Suspense and opened on demand
// from the header modal — defer this wrapper's hydration to InView.
export default withWidget(YourSolutionRoot, 'YourSolutionRoot', {
    hydrate: HydrateOption.InView,
});
